<script lang="ts">
	import Notification from './Notification.svelte';
	import { dismissNotification, notifications } from './Notificationstore';
</script>

{#if $notifications}
	<section class="flex flex-col items-center gap-2 fixed bottom-0 pointer-events-none">
		{#each $notifications as toast (toast.id)}
			<Notification
				type={toast.type}
				dismissible={toast.dismissible}
				button={toast.button}
				onDismiss={() => dismissNotification(toast.id!)}
				><div>
					<p>{toast.message}</p>
				</div></Notification
			>
		{/each}
	</section>
{/if}

<style>
	section {
		position: fixed;
		bottom: 30px;
		left: 0;
		right: 0;
		width: 100%;
		margin-top: 1rem;
		z-index: 1000;
	}
</style>
